import { render, staticRenderFns } from "./ArmariosLista.vue?vue&type=template&id=47ec6f2b&scoped=true"
import script from "./ArmariosLista.vue?vue&type=script&lang=js"
export * from "./ArmariosLista.vue?vue&type=script&lang=js"
import style0 from "./ArmariosLista.vue?vue&type=style&index=0&id=47ec6f2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec6f2b",
  null
  
)

export default component.exports